import { ReactElement } from 'react';
import { Link } from 'react-scroll';

import config from '../config/index.json';

interface INavigationLinks {
    containerClass: string;
    linkClass: string;
}

export const NavigationLinks = ({ containerClass, linkClass }: INavigationLinks): ReactElement => {
    const { navigation } = config;

    return (
        <div className={containerClass}>
            {navigation.map((item) => (
                <Link
                    spy={true}
                    active='active'
                    smooth={true}
                    duration={1000}
                    key={item.name}
                    to={item.href}
                    className={linkClass}
                >
                    {item.name}
                </Link>
            ))}
        </div>
    );
};
